import {dayNames} from '../core/constants/day-names.const';

export function getDayName(day: number): string {
  return dayNames[day];
}
